export const MODULE_GROUPS = [
  {
    "id": "academyManagement",
    "title": "🎓 Academy Management",
    "module": "academy-management",
    "items": [
      [
        "/company/academy",
        "Overview"
      ],
      [
        "/company/academy/categories",
        "Categories"
      ],
      [
        "/company/academy/bootcamp-types",
        "Bootcamp Types"
      ],
      [
        "/company/academy/cohorts",
        "Cohorts"
      ],
      [
        "/company/academy/students",
        "Students"
      ],
      [
        "/company/academy/enrollments",
        "Enrollments"
      ],
      [
        "/company/academy/calendar",
        "Calendar"
      ],
      [
        "/company/academy/attendance",
        "Attendance"
      ],
      [
        "/company/academy/assessments",
        "Assessments"
      ],
      [
        "/company/academy/instructors",
        "Instructors"
      ],
      [
        "/company/academy/contracts",
        "Contracts"
      ],
      [
        "/company/academy/payments",
        "Payments"
      ],
      [
        "/company/academy/finance",
        "Finance"
      ],
      [
        "/company/academy/certificates",
        "Certificates"
      ],
      [
        "/company/academy/documents",
        "Documents"
      ],
      [
        "/company/academy/history",
        "History"
      ],
      [
        "/company/academy/settings",
        "Settings"
      ]
    ]
  },
  {
    "id": "companyManagement",
    "title": "🏢 Company Management",
    "module": null,
    "items": [
      [
        "/companies",
        "Overview"
      ],
      [
        "/companies/create",
        "Create Company"
      ]
    ]
  },
  {
    "id": "organization",
    "title": "🏗️ Organization Structure",
    "module": "human-resources",
    "items": [
      [
        "/company/departments",
        "Departments"
      ],
      [
        "/company/positions",
        "Positions"
      ],
      [
        "/company/position-levels",
        "Position Levels"
      ],
      [
        "/company/unit-types",
        "Unit Types"
      ],
      [
        "/company/org-chart",
        "Org Chart"
      ]
    ]
  },
  {
    "id": "employees",
    "title": "👥 Employee Management",
    "module": "human-resources",
    "items": [
      [
        "/company/employees",
        "Employee Directory"
      ],
      [
        "/company/work-schedules",
        "Work Schedules"
      ],
      [
        "/company/attendance",
        "Attendance & Timesheet"
      ],
      [
        "/company/leave-management",
        "Leave Management"
      ],
      [
        "/company/scheduled-changes",
        "Scheduled Changes"
      ],
      [
        "/company/pending-actions",
        "Pending Actions"
      ]
    ]
  },
  {
    "id": "payroll",
    "title": "💰 Payroll & Finance",
    "module": "human-resources",
    "items": [
      [
        "/company/payroll",
        "Payroll & Compensation"
      ],
      [
        "/company/insurance",
        "Insurance Tracking"
      ],
      [
        "/company/hr-payroll",
        "Payroll (Legacy)"
      ]
    ]
  },
  {
    "id": "outsourcing",
    "title": "🤝 Outsourcing Management",
    "module": "outsourcing-management",
    "items": [
      [
        "/company/outsourcing/private-projects",
        "Private projects"
      ],
      [
        "/company/outsourcing/overview",
        "Overview"
      ],
      [
        "/company/outsourcing/clients",
        "Clients"
      ],
      [
        "/company/outsourcing/assignments",
        "Employee Assignments"
      ],
      [
        "/company/outsourcing/services",
        "Services"
      ],
      [
        "/company/outsourcing/billing",
        "Monthly Billing"
      ],
      [
        "/company/outsourcing/billing-history",
        "Billing History"
      ],
      [
        "/company/outsourcing/accounting",
        "Accounting Handoff"
      ]
    ]
  },
  {
    "id": "leadsManagement",
    "title": "🎯 Leads Management",
    "module": "leads-management",
    "items": [
      [
        "/company/leads",
        "Overview"
      ],
      [
        "/company/leads/directory",
        "Lead Directory"
      ],
      [
        "/company/leads/pipeline",
        "Pipeline"
      ],
      [
        "/company/leads/activities",
        "Activities & Follow-Ups"
      ],
      [
        "/company/leads/proposals",
        "Proposals"
      ],
      [
        "/company/leads/sources",
        "Lead Sources"
      ],
      [
        "/company/leads/audit",
        "Audit History"
      ],
      [
        "/company/leads/settings",
        "Settings"
      ]
    ]
  },
  {
    "id": "accounting",
    "title": "💰 Basic Accounting",
    "module": "financial-dashboard",
    "items": [
      [
        "/company/finance",
        "Financial Overview"
      ],
      [
        "/company/finance/projects",
        "Projects & Structure"
      ],
      [
        "/company/finance/payers",
        "Payers / Customers"
      ],
      [
        "/company/finance/receivables",
        "Income / Receivables"
      ],
      [
        "/company/finance/payees",
        "Payees / Suppliers"
      ],
      [
        "/company/finance/payables",
        "Expenses / Payables"
      ],
      [
        "/company/finance/transactions",
        "Transactions"
      ],
      [
        "/company/finance/petty-cash",
        "Petty Cash"
      ],
      [
        "/company/finance/due-payments",
        "Due & Upcoming"
      ],
      [
        "/company/finance/reports",
        "Reports & History"
      ],
      [
        "/company/finance/settings",
        "Settings"
      ]
    ]
  },
  {
    "id": "servicesManagement",
    "title": "🛠️ Services Management",
    "module": "services-management",
    "items": [
      [
        "/company/services",
        "Services Overview"
      ],
      [
        "/company/services/catalog",
        "Service Catalog"
      ],
      [
        "/company/services/engagements",
        "Engagements"
      ],
      [
        "/company/services/categories",
        "Categories"
      ],
      [
        "/company/services/analytics",
        "Analytics"
      ],
      [
        "/company/services/settings",
        "Settings & History"
      ]
    ]
  },
  {
    "id": "projectManagement",
    "title": "📊 Project Management",
    "module": "project-management",
    "items": [
      [
        "/company/projects",
        "Overview"
      ],
      [
        "/company/projects/directory",
        "Project Directory"
      ],
      [
        "/company/projects/settings",
        "Settings"
      ]
    ]
  },
  {
    "id": "clientManagement",
    "title": "👥 Client Management",
    "module": "client-management",
    "items": [
      [
        "/company/clients",
        "Overview"
      ],
      [
        "/company/clients/directory",
        "Client Directory"
      ],
      [
        "/company/clients/settings",
        "Settings"
      ]
    ]
  },
  {
    "id": "invoicing",
    "title": "🧾 Invoicing Management",
    "module": "invoicing-management",
    "items": [
      [
        "/company/invoicing",
        "Overview"
      ],
      [
        "/company/invoicing/invoices",
        "Invoices"
      ],
      [
        "/company/invoicing/settings",
        "Settings"
      ]
    ]
  },
  {
    "id": "boostManagement",
    "title": "🚀 Boost Management",
    "module": "boost-management",
    "items": [
      [
        "/company/boosts",
        "Overview"
      ],
      [
        "/company/boosts/entries",
        "Boost Entries"
      ],
      [
        "/company/boosts/settings",
        "Settings"
      ]
    ]
  },
  {
    "id": "orderManagement",
    "title": "📦 Order Management",
    "module": "order-management",
    "items": [
      [
        "/company/orders",
        "Overview"
      ],
      [
        "/company/orders/list",
        "Orders"
      ],
      [
        "/company/orders/fulfillment",
        "Fulfillment & Deliveries"
      ],
      [
        "/company/orders/settings",
        "Settings"
      ]
    ]
  },
  {
    "id": "commissionManagement",
    "title": "💰 Commissions",
    "module": "commission-management",
    "items": [
      [
        "/company/commissions",
        "Overview"
      ],
      [
        "/company/commissions/entries",
        "Commission entries"
      ],
      [
        "/company/commissions/beneficiaries",
        "Commission recipients"
      ],
      [
        "/company/commissions/settlements",
        "Payments"
      ]
    ]
  },
  {
    "id": "inventoryManagement",
    "title": "📦 Inventory & Stock",
    "module": "inventory-stock-management",
    "items": [
      [
        "/company/inventory",
        "Overview"
      ],
      [
        "/company/inventory/products",
        "Products"
      ],
      [
        "/company/inventory/categories",
        "Categories"
      ],
      [
        "/company/inventory/warehouses",
        "Warehouses & Locations"
      ],
      [
        "/company/inventory/movements",
        "Stock Movements"
      ],
      [
        "/company/inventory/counts",
        "Stock Counts"
      ],
      [
        "/company/inventory/adjustments",
        "Adjustments"
      ],
      [
        "/company/inventory/reservations",
        "Reservations"
      ],
      [
        "/company/inventory/transfers",
        "Transfers"
      ],
      [
        "/company/inventory/picking",
        "Picking & Fulfillment"
      ],
      [
        "/company/inventory/returns",
        "Customer Returns"
      ],
      [
        "/company/inventory/history",
        "History"
      ],
      [
        "/company/inventory/settings",
        "Settings"
      ]
    ]
  },
  {
    "id": "procurementManagement",
    "title": "🛒 Procurement",
    "module": "procurement-management",
    "items": [
      [
        "/company/procurement",
        "Overview"
      ],
      [
        "/company/procurement/suppliers",
        "Suppliers"
      ],
      [
        "/company/procurement/purchase-requests",
        "Purchase Requests"
      ],
      [
        "/company/procurement/purchase-orders",
        "Purchase Orders"
      ],
      [
        "/company/procurement/receiving",
        "Receiving"
      ],
      [
        "/company/procurement/supplier-invoices",
        "Supplier Invoices"
      ],
      [
        "/company/procurement/settings",
        "Settings"
      ]
    ]
  },
  {
    "id": "rolesPermissions",
    "title": "🔐 Roles & Permissions",
    "module": "roles-permissions",
    "items": [
      [
        "/company/roles-permissions",
        "Overview"
      ],
      [
        "/company/roles-permissions/positions",
        "Positions & Presets"
      ],
      [
        "/company/roles-permissions/users",
        "Users & Overrides"
      ],
      [
        "/company/roles-permissions/grants",
        "Company / Module / Submodule"
      ],
      [
        "/company/roles-permissions/timed-access",
        "Timed Access"
      ],
      [
        "/company/roles-permissions/history",
        "History"
      ],
      [
        "/company/roles-permissions/settings",
        "Settings"
      ]
    ]
  },
  {
    "id": "qaManagement",
    "title": "🔍 QA Management",
    "module": "qa-management",
    "items": [
      [
        "/company/qa",
        "QA Overview"
      ]
    ]
  },
  {
    "id": "hrSettings",
    "title": "⚙️ HR Settings",
    "module": "human-resources",
    "items": [
      [
        "/company/hr-profiles",
        "HR Profiles"
      ]
    ]
  }
];

const uniqueIds = value => Array.isArray(value)
  ? [...new Set(value.filter(id => typeof id === 'string' && id.trim()).map(id => id.trim()))]
  : [];

const cleanPreferences = value => ({
  order: uniqueIds(value?.order),
  hidden: uniqueIds(value?.hidden).filter(id => id !== 'overview'),
});

const cleanPath = pathname => String(pathname || '/').split(/[?#]/)[0].replace(/\/+$/, '') || '/';

export function resolveWorkspaceId(pathname, storedCompanyId) {
  const path = cleanPath(pathname);
  if (path === '/' || /^\/(companies|users|holding)(?:\/|$)/.test(path)) return 'holding';
  const dashboardId = path.match(/^\/dashboard\/(\d+)(?:\/|$)/)?.[1];
  if (dashboardId) return dashboardId;
  const stored = storedCompanyId == null ? '' : String(storedCompanyId);
  return stored && !['undefined', 'null'].includes(stored) ? stored : 'holding';
}

// Availability is derived from the existing workspace assignments. Preferences
// below only change presentation; they cannot grant or revoke access.
export function availableNavigation({ workspaceId = 'holding', workspace = null, role } = {}) {
  const isHolding = String(workspaceId) === 'holding';
  const matchesWorkspace = !isHolding && String(workspace?.id) === String(workspaceId);
  const hasModule = slug => matchesWorkspace && Array.isArray(workspace?.assigned_modules)
    && workspace.assigned_modules.some(module => module?.slug === slug);
  const overviewPath = isHolding ? '/' : `/dashboard/${encodeURIComponent(workspaceId)}/overview`;
  const groups = [{
    id: 'overview',
    title: isHolding ? '📊 Holding Overview' : '📊 Company Overview',
    module: null,
    items: [[overviewPath, 'Overview']],
  }];

  if (hasModule('human-resources')) {
    groups.push({ id: 'hrOverview', title: '📈 HR Overview', module: 'human-resources', items: [['/company/hr-overview', 'HR Overview']] });
  }

  MODULE_GROUPS.forEach(group => {
    const available = isHolding
      ? group.id === 'companyManagement' || (group.id === 'accounting' && ['super_admin', 'holding_admin'].includes(role))
      : group.module && hasModule(group.module);
    if (!available) return;
    let items = group.items.map(([path, label]) => [
      isHolding && group.id === 'accounting' ? path.replace('/company/finance', '/holding/finance') : path,
      label,
    ]).filter(([path]) => path !== '/company/outsourcing/private-projects' || role === 'super_admin');
    let title = group.title;
    if (group.id === 'invoicing' && hasModule('academy-management')) {
      title = '🧾 Receipts';
      items = [['/company/invoicing/invoices', 'Student receipts']];
    }
    if (items.length) groups.push({ ...group, title, items });
  });

  if (isHolding && role === 'super_admin') {
    groups.push({ id: 'users', title: '👥 Users', module: null, items: [['/users', 'Users']] });
  }
  return groups;
}

export function activeNavigation(groups, pathname) {
  const path = cleanPath(pathname);
  const entries = (Array.isArray(groups) ? groups : []).flatMap(group =>
    group.items.map(item => ({ group, item })));
  const exact = entries.find(entry => entry.item[0] === path);
  if (exact) return exact;

  const aliases = [
    [/^\/company\/projects\/\d+(?:\/|$)/, '/company/projects/directory'],
    [/^\/company\/clients\/\d+(?:\/|$)/, '/company/clients/directory'],
    [/^\/company\/leads\/\d+(?:\/|$)/, '/company/leads/directory'],
    [/^\/employees\/\d+(?:\/|$)/, '/company/employees'],
    [/^\/dashboard\/\d+$/, `${path}/overview`],
  ];
  const alias = aliases.find(([pattern]) => pattern.test(path));
  if (alias) {
    const destination = entries.find(entry => entry.item[0] === alias[1]);
    if (destination) return destination;
  }
  return entries.filter(entry => entry.item[0] !== '/' && path.startsWith(`${entry.item[0]}/`))
    .sort((left, right) => right.item[0].length - left.item[0].length)[0]
    || { group: null, item: null };
}

export function preferenceKey(userId, workspaceId) {
  return `access.navigation.v1:${encodeURIComponent(String(userId ?? 'anonymous'))}:${encodeURIComponent(String(workspaceId ?? 'holding'))}`;
}

export function readNavigationPreferences(key) {
  try { return cleanPreferences(JSON.parse(localStorage.getItem(key) || 'null')); }
  catch { return cleanPreferences(null); }
}

export function saveNavigationPreferences(key, preferences) {
  try {
    localStorage.setItem(key, JSON.stringify(cleanPreferences(preferences)));
    return true;
  } catch { return false; }
}

export function orderedNavigation(groups, preferences, { includeHidden = false } = {}) {
  const { order, hidden } = cleanPreferences(preferences);
  const available = Array.isArray(groups) ? groups : [];
  const byId = new Map(available.map(group => [group.id, group]));
  const orderedIds = [...order.filter(id => byId.has(id)), ...available.map(group => group.id).filter(id => !order.includes(id))];
  return orderedIds.filter(id => includeHidden || id === 'overview' || !hidden.includes(id)).map(id => byId.get(id));
}

// Move the source into the target's position, keeping the remaining IDs stable.
export function moveNavigationItem(ids, sourceId, targetId) {
  const result = uniqueIds(ids);
  const sourceIndex = result.indexOf(sourceId);
  const targetIndex = result.indexOf(targetId);
  if (sourceIndex < 0 || targetIndex < 0 || sourceIndex === targetIndex) return result;
  result.splice(sourceIndex, 1);
  result.splice(targetIndex, 0, sourceId);
  return result;
}
